import { Entry } from "@zip.js/zip.js";

export const getFilePaths = (entries: Entry[]) => {
  return Object.values(entries)
    .filter((file) => file.directory === false) // Directories are also entries in ZIP files
    .map((file) => file.filename);
};

export const getFilenames = (filePaths: string[]) => {
  return filePaths.map((filePath) => filePath.split("/").pop());
};
